var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
var containerPadding = 1;
var buttonSize = 0.6;
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: ", "rem;\n  padding: ", "rem 0;\n  transform: translateX(-50%);\n  transition: width 0.2s;\n  overflow: hidden;\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n"], ["\n  display: flex;\n  width: ", "rem;\n  padding: ", "rem 0;\n  transform: translateX(-50%);\n  transition: width 0.2s;\n  overflow: hidden;\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n"])), function (_a) {
  var dotsToShow = _a.dotsToShow,
      offset = _a.offset;
  return (containerPadding + buttonSize) * ((dotsToShow || 0) + (offset || 0));
}, containerPadding);
export var Text = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "rem;\n  height: ", "rem;\n  display: block;\n  text-indent: -9999rem;\n  background-color: #fff;\n  border-radius: 50%;\n  transform-origin: center center;\n"], ["\n  width: ", "rem;\n  height: ", "rem;\n  display: block;\n  text-indent: -9999rem;\n  background-color: #fff;\n  border-radius: 50%;\n  transform-origin: center center;\n"])), buttonSize, buttonSize);
export var Button = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0 0.5rem;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  appearance: none;\n  user-select: none;\n"], ["\n  padding: 0 0.5rem;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  appearance: none;\n  user-select: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3;